import React, { ReactNode } from 'react';
import { Row, Col, Space, Divider } from 'antd';
import IconWatch from '../Icons/IconWatch';
import Text from '../Text';
import IconUser from '../Icons/IconUser';
import Wrapper from '../Wrapper';
import './AgendaCard.less';

export type AgendaCardProps = {
  cover?: string;
  customCover?: {
    backgroundColor: string;
    icon: string;
    borderStyle: string;
  };
  title?: ReactNode;
  author?: string;
  authorAvatar?: string;
  dates?: Array<string>;
  onClick?: () => void;
};

const AgendaCard: React.FC<AgendaCardProps> = ({
  dates = [],
  cover,
  customCover,
  authorAvatar,
  author,
  onClick = () => {},
  title,
}) => {
  return (
    <div
      style={{
        backgroundColor: customCover.backgroundColor,
        border: customCover.borderStyle,
      }}
      className="t-agenda-card"
      onClick={() => onClick()}
    >
      <div className="t-agenda-card-wrapper">
        <Row align="middle">
          <Col span={24}>
            <Wrapper display="flex" justifyContent="start" alignItems="start">
              <span className="t-icon-section">
                <img src={customCover.icon} alt="book_icon" />
              </span>

              <Wrapper ml={2} display="flex" alignItems="center">
                <Text
                  rows={2}
                  semiBold
                  textColor="dark-100"
                  level={2}
                  title={String(title)}
                >
                  {title}
                </Text>
              </Wrapper>
            </Wrapper>

            <Divider style={{ margin: '16px 0' }} />

            <Wrapper display="flex">
              <Wrapper display="flex" alignItems="center" style={{ gap: 10 }}>
                {!!dates.length &&
                  dates.map((item, index) => {
                    return (
                      <Wrapper display="flex" alignItems="center" key={index}>
                        <span className="iconStyle">
                          <IconWatch fill="#4E25E6" size="xs" />
                        </span>
                        <Text
                          rows={1}
                          textColor="dark-100"
                          level={3}
                          title={String(item)}
                        >
                          {item}
                        </Text>
                      </Wrapper>
                    );
                  })}

                <span className="dotStyle">&bull;</span>

                {!!author && (
                  <Wrapper display="flex" alignItems="center">
                    {!!authorAvatar ? (
                      <div className="t-authorAvatar">
                        <img src={authorAvatar} alt="author_icon" />
                      </div>
                    ) : (
                      <span className="iconStyle">
                        <IconUser fill="#4E25E6" size="xs" />
                      </span>
                    )}
                    <Text
                      rows={1}
                      textColor="dark-100"
                      level={3}
                      title={String(author)}
                    >
                      {author}
                    </Text>
                  </Wrapper>
                )}
              </Wrapper>
            </Wrapper>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AgendaCard;
